var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleDeleteBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 8.5,
    fill: "white",
    stroke: "#D9E1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41963 8.72899L11.8172 6.33145L12.2702 6.78444L9.87262 9.18198L12.2591 11.5685L11.8061 12.0215L9.41963 9.63497L7.03314 12.0215L6.58015 11.5685L8.96664 9.18198L6.5691 6.78444L7.02209 6.33145L9.41963 8.72899Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleDeleteBtn);
export default __webpack_public_path__ + "static/media/role-delete-btn.2203fce3e4559e06f8a10a805d2378f2.svg";
export { ForwardRef as ReactComponent };